var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.499756,
    width: 4.00012,
    height: 1.00003,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1.49976,
    width: 1.00003,
    height: 8.00023,
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.00049,
    y: 13.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9995,
    y: 15.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0005,
    y: 11.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10.5002,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.00049,
    y: 7.5,
    width: 1.00003,
    height: 3.00009,
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12.5002,
    width: 2.00006,
    height: 1.00003,
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0005,
    y: 10.5002,
    width: 4.00012,
    height: 1.00003,
    fill: "#232323"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.5002,
    width: 1.00003,
    height: 4.00012,
    fill: "#232323"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16.5002,
    width: 7.0002,
    height: 1.00003,
    fill: "#232323"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.5,
    width: 1.00003,
    height: 2.00006,
    fill: "#232323"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1.49976,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2.49976,
    width: 1.00003,
    height: 4.00012,
    fill: "#232323"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6.49976,
    width: 1.00003,
    height: 1.00003,
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.b6daa5d038d691cffd49c7285bc59fe3.svg";
export { ForwardRef as ReactComponent };